/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ClearanceCaseListResult {
  InvalidFilter = 0,
  InvalidUser = 1,
  InvalidCompany = 2,
  Error = 3,
  Success = 4,
  InvalidDepartment = 5,
}
